import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);
  const location = useLocation();
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Add or remove the 'mobile-nav-active' class to the header element
    const headerElement = document.getElementById('header');
    if (isMobileNavActive) {
      headerElement.classList.add('mobile-nav-active');
    } else {
      headerElement.classList.remove('mobile-nav-active');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      if (headerElement) {
        headerElement.classList.remove('mobile-nav-active');
      }
    };
  }, [isMobileNavActive]);

  const toggleMobileNav = () => {
    setIsMobileNavActive(!isMobileNavActive);
  };

  const closeMobileNav = () => {
    setIsMobileNavActive(false);
  };

  return (
    <header id="header" className={`header d-flex align-items-center fixed-top ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        <Link to="/" className={`logo d-flex align-items-center ${isScrolled ? 'logo-scrolled' : ''}`}>
          <img className="logo-img" src={`${process.env.PUBLIC_URL}/assets/img/EKK-LOGO.jpg`} alt="Eagle Industry Indonesia" />
          <h1 className={`sitename ${isScrolled ? 'sitename-scrolled' : ''}`}>P.T. Eagle Industry Indonesia</h1>
          <span className={`dot ${isScrolled ? 'dot-scrolled' : ''}`}></span>
        </Link>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <Link to="/" className={`${location.pathname === '/' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                {t('header.home')}
              </Link>
            </li>
            <li>
              <Link to="/company" className={`${location.pathname === '/company' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                {t('header.company')}
              </Link>
            </li>
            <li>
              <Link to="/sustainability" className={`${location.pathname === '/sustainability' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                {t('header.sustainability')}
              </Link>
            </li>
            <li>
              <Link to="/products" className={`${location.pathname === '/products' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                {t('header.products')}
              </Link>
            </li>
            <li>
              <Link to="/services/custom-manufacturing" className={`${location.pathname === '/services/custom-manufacturing' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                {t('header.ourServices')}
              </Link>
            </li>
            {/* <li>
              <Link to="/blog" className={`${location.pathname === '/blog' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                Blog/News
              </Link>
            </li> */}
            <li>
              <Link to="/contact" className={`${location.pathname === '/contact' ? 'active' : ''} ${isScrolled ? 'nav-scrolled' : ''}`} onClick={closeMobileNav}>
                {t('header.inquiryForm')}
              </Link>
            </li>
            <li className="language-switcher">
              <button
                className={`language-btn ${isScrolled ? 'nav-scrolled' : ''}`}
                onClick={toggleLanguage}
                title={t('header.language')}
              >
                {language === 'en' ? 'ID' : 'EN'}
              </button>
            </li>
          </ul>
        </nav>
        <i
          className={`mobile-nav-toggle d-xl-none bi ${isMobileNavActive ? 'bi-x' : 'bi-list'} ${isScrolled ? 'mobile-nav-scrolled' : ''}`}
          onClick={toggleMobileNav}
        ></i>
      </div>
    </header>
  );
};

export default Header;